import { NgModule } from "@angular/core";
import { RouterModule } from "@angular/router";
import { AutoLogOutModule } from "@features/autoLogout/auto-log-out.module";
import { CustomOtpModule } from "@features/custom-otp/custom-otp.module";
import { CdkCustomMdlModule } from "@features/customCDK/cdkCustomMdl/cdk-custom-mdl.module";
import { SharedModule } from "@shared/shared.module";
import { LoginComponent } from "./login.component";

@NgModule({
  declarations: [LoginComponent],
  imports: [
    SharedModule,
    CustomOtpModule,
    CdkCustomMdlModule,
    RouterModule.forChild([
      {
        path: '',
        component: LoginComponent
      }
    ])
  ],
})
export class LoginModule { }
